import {Radio} from "antd";
import "../../../asset/style/scanner/scanner.css";

export const getRadioButtons = (LIST_OBJECT, props="", disabled=false) => Object.keys(LIST_OBJECT).map((object) => {
	let valueforkey = LIST_OBJECT[object];
	return <Radio.Button value={valueforkey} style={{padding: '0px 4px'}}
						 className={valueforkey === props ? "black-scanner-btn" : "default-radio-btn"}>
		{object}
	</Radio.Button>
});